import parseCookie from "./parse-cookie";

/* eslint-disable complexity */
export const getAttributionParams = ({firstAttributionCookie, lastAttributionCookie, path, extraParams = {}}) => {
    const {gaId, ...rest} = extraParams || {};
    const sourceQuery = {
        ...(rest && rest),
        ...(gaId && {ga_id: gaId}),
        "first_attribution": {
            "query_param": {
                "utm_source": firstAttributionCookie ? firstAttributionCookie.utm_source : "",
                "utm_medium": firstAttributionCookie ? firstAttributionCookie.utm_medium : "",
                "utm_keyword": firstAttributionCookie ? firstAttributionCookie.utm_keyword : "",
                "utm_matchtype": firstAttributionCookie ? firstAttributionCookie.utm_matchtype : "",
                "utm_device": firstAttributionCookie ? firstAttributionCookie.utm_device : "",
                "adgroup_id": firstAttributionCookie ? firstAttributionCookie.adgroup_id : "",
                "campaign_id": firstAttributionCookie ? firstAttributionCookie.campaign_id : "",
                "gclid": firstAttributionCookie ? firstAttributionCookie.gclid : "",
                "utm_campaign": firstAttributionCookie ? firstAttributionCookie.utm_campaign : ""
            },
            path,
            "source": document.referrer ? document.referrer : "",
            "full_url": decodeURIComponent(parseCookie("car_service_first_click_url"))
        },
        "last_attribution": {
            "last_query_param": {
                "utm_source": lastAttributionCookie ? lastAttributionCookie.utm_source : "",
                "utm_medium": lastAttributionCookie ? lastAttributionCookie.utm_medium : "",
                "utm_keyword": lastAttributionCookie ? lastAttributionCookie.utm_keyword : "",
                "utm_matchtype": lastAttributionCookie ? lastAttributionCookie.utm_matchtype : "",
                "utm_device": lastAttributionCookie ? lastAttributionCookie.utm_device : "",
                "adgroup_id": lastAttributionCookie ? lastAttributionCookie.adgroup_id : "",
                "campaign_id": lastAttributionCookie ? lastAttributionCookie.campaign_id : "",
                "gclid": lastAttributionCookie ? lastAttributionCookie.gclid : "",
                "utm_campaign": lastAttributionCookie ? lastAttributionCookie.utm_campaign : ""
            },
            "last_path": path,
            "last_source": document.referrer ? document.referrer : "",
            "full_url": decodeURIComponent(parseCookie("car_service_first_click_url"))
        }
    };
    return sourceQuery;
};
